module.exports = __webpack_public_path__ + "img/icon2.14b4f757.png";